export default class ShipTypeRepoStatic {
  constructor() {
    //console.log("Construyendo ShipTypeRepoStatic");
  }

  getShipType(ref, ship, callback) {
    // console.log("ShipTypeRepoStatic-getShipType", ref)
    const obj = {
      id: "ST-1",
      a: 23,
      c: 45,
      name: "ST-1",
      code: "ST-1",
    };
    callback(ref, ship, obj);
  }
}
